module.exports = __webpack_public_path__ + "img/kulturminner.22e83d65.jpg";